(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-grid/assets/javascripts/casino-grid-virtualized.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-grid/assets/javascripts/casino-grid-virtualized.js');

'use strict';

const _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["tabIndex"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const {
  VirtuosoGrid
} = ReactVirtuoso;
const {
  forwardRef,
  useMemo,
  useState,
  useCallback,
  useEffect,
  useRef
} = React;
const CasinoGameCard = svs.components.casino_react.casinoGameCard.CasinoGameCard;
const CasinoProviderCard = svs.components.casino_react.casinoProviderCard.CasinoProviderCard;
const CasinoCategoryCard = svs.components.casino_react.casinoCategoryCard.CasinoCategoryCard;
const {
  CasinoGridSkeleton
} = svs.components.casino_react;
const {
  constants: {
    CardType,
    GridDisplayModes,
    GridRulesets,
    DefaultNumberOfCasinoGridItems
  }
} = svs.components.casino_react.common;
const {
  useMaxGridItems,
  useSearchParams
} = svs.components.casino_react.hooks;
const {
  useLazyGetSearchResultQuery
} = svs.components.casino_react.casinoStore.endpoints.searchApi;
const getItemCount = _ref => {
  let {
    maxItems,
    preferredNumberOfItems
  } = _ref;
  return Math.min(maxItems, preferredNumberOfItems);
};
const approximateCardHeight = 300;
const createGridComponents = () => ({
  List: forwardRef((_ref2, ref) => {
    let {
        children
      } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded);
    return React.createElement("ul", _extends({
      ref: ref
    }, props), children);
  }),
  Item: forwardRef((_ref3, ref) => {
    let {
        children
      } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded2);
    return React.createElement("li", _extends({
      ref: ref
    }, props), children);
  }),
  Scroller: forwardRef((_ref4, ref) => {
    let {
        children
      } = _ref4,
      props = _objectWithoutProperties(_ref4, _excluded3);
    const {
        tabIndex
      } = props,
      restProps = _objectWithoutProperties(props, _excluded4);
    return React.createElement("div", _extends({
      ref: ref
    }, restProps), children);
  })
});
const CasinoGridVirtualized = _ref5 => {
  let {
    displayMode,
    items,
    isLoading,
    totalGamesCount
  } = _ref5;
  const ruleset = GridRulesets[displayMode];
  const itemsToRender = useMaxGridItems(items, ruleset);
  const [fetchMore] = useLazyGetSearchResultQuery();
  const {
    q: queryString,
    tags,
    providers: decodedProviders,
    listIds,
    categories,
    sorting
  } = useSearchParams();
  const providers = decodedProviders === null || decodedProviders === void 0 ? void 0 : decodedProviders.map(encodeURIComponent);
  const oldQuery = useRef(queryString);
  const [isListVisible, setIsListVisible] = useState(false);
  const hasReachedEndWithoutFetchingMore = useRef({
    check: true,
    offset: null
  });
  const gridComponents = useMemo(() => createGridComponents(), []);
  const randomGridIdSelector = Math 
  .random().toString(16).slice(2);
  const gridKey = useMemo(() => {
    const tagsString = Array.isArray(tags) ? tags.join(',') : '';
    const providerString = Array.isArray(providers) ? providers.join(',') : '';
    const categoriesString = Array.isArray(categories) ? categories.join(',') : '';
    const listIdsString = Array.isArray(listIds) ? listIds.join(',') : '';
    return "".concat(queryString || 'empty', "-").concat(tagsString, "-").concat(providerString, "-").concat(categoriesString, "-").concat(listIdsString, "-").concat(sorting);
  }, [tags, providers, categories, listIds, queryString, sorting]);
  const intersectionCallback = useCallback(entries => {
    entries.forEach(entry => {
      setIsListVisible(entry.isIntersecting);
    });
  }, []);
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };
    const observer = new IntersectionObserver(intersectionCallback, options);
    const gridElement = document.querySelector(".casino-grid-virtualized-".concat(randomGridIdSelector));
    if (gridElement) {
      observer.observe(gridElement);
    }
    return () => {
      if (gridElement) {
        observer.unobserve(gridElement);
      }
    };
  }, [intersectionCallback, randomGridIdSelector]);
  useEffect(() => {
    const offset = hasReachedEndWithoutFetchingMore.current.offset;
    const existMoreGamesToLoad = offset < totalGamesCount;
    if (isListVisible && offset !== null && existMoreGamesToLoad && hasReachedEndWithoutFetchingMore.current.check) {
      fetchMore({
        offset: hasReachedEndWithoutFetchingMore.current.offset,
        count: DefaultNumberOfCasinoGridItems * 3,
        searchQuery: queryString,
        tags,
        providers,
        categories,
        listIds,
        sorting
      });
      hasReachedEndWithoutFetchingMore.current.check = false;
    }
  }, [isListVisible]);
  useEffect(() => {
    if (oldQuery.current !== queryString) {
      hasReachedEndWithoutFetchingMore.current.offset = null;
    }
  }, [queryString]);

  if (isLoading && hasReachedEndWithoutFetchingMore.current.offset === null) {
    return React.createElement(CasinoGridSkeleton, {
      displayMode: displayMode
    });
  }
  return React.createElement(VirtuosoGrid, {
    className: "casino-grid-virtualized casino-grid-virtualized-".concat(randomGridIdSelector),
    components: gridComponents,
    endReached: endIndex => {
      const offset = endIndex + 1;
      const existMoreGamesToLoad = offset < totalGamesCount;
      if (!existMoreGamesToLoad) {
        return;
      }
      if (isListVisible) {
        fetchMore({
          offset,
          count: DefaultNumberOfCasinoGridItems * 3,
          searchQuery: queryString,
          tags,
          providers,
          categories,
          listIds,
          sorting
        });
        oldQuery.current = queryString;
      } else {
        hasReachedEndWithoutFetchingMore.current.check = true;
      }
      hasReachedEndWithoutFetchingMore.current.offset = offset;
    },
    initialItemCount: getItemCount({
      maxItems: itemsToRender.length,
      preferredNumberOfItems: DefaultNumberOfCasinoGridItems * 2
    }),
    itemClassName: "casino-grid__item ".concat(ruleset.childClassList.join(' ')),
    itemContent: index => {
      const item = itemsToRender[index];
      return React.createElement(React.Fragment, null, item.type === CardType.GAME && React.createElement(CasinoGameCard, _extends({
        gameName: item.model.name
      }, ruleset.cardComponentProps)), item.type === CardType.PROVIDER && React.createElement(CasinoProviderCard, {
        providerName: item.model.systemName
      }), item.type === CardType.CATEGORY && React.createElement(CasinoCategoryCard, {
        categoryName: item.model.systemName
      }));
    },
    key: gridKey,
    listClassName: "casino-grid",
    overscan: approximateCardHeight * 6 
    ,
    totalCount: itemsToRender.length,
    useWindowScroll: true
  });
};
setGlobal('svs.components.casino_react.CasinoGridVirtualized', CasinoGridVirtualized);

 })(window);